import { useState } from "react";
import { Accordion } from "react-bootstrap";
import { useSelector } from "react-redux";
import AddSupplier from "./AddSupplier";

const SupplierMasterData = ({ setSupplierId, setShow, setView, setCurrentVal, searchTerm, sortConfig }) => {
    const [selectedRow, setSelectedRow] = useState({});
    const [showOffcanvas, setShowOffcanvas] = useState(false);
    const [operation, setOperation] = useState();
    const loading = useSelector((state) => state.teammanagement.loading)
    const error = useSelector((state) => state.teammanagement.error)
    const supplierData = useSelector((state) => state.teammanagement.data.supplier)

    if (loading) {
        return (
            <>
                <main className="col-md-12">
                    <h1 className="h2 py-2"> <i class="fa-solid fa-spinner fa-spin"></i></h1>
                </main>
            </>
        )
    }

    const handleEditClick = (row) => {
        setSelectedRow(row);
        setShowOffcanvas(!showOffcanvas);
        setOperation("update")
    };

    const handleDeleteModal = (id, event) => {
        event.stopPropagation();
        setShow(true);
        setSupplierId(id);
    }

    const handleView = (curEmpData, event) => {
        event.stopPropagation();
        setView(true);
        setCurrentVal(curEmpData)
    }

    const filteredData = supplierData.results
        ? supplierData.results.filter((curData) => {
            const { id, name, contact_person_name, supervisor_name, department_names } = curData;
            return (
                id?.toString().includes(searchTerm) ||
                name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
                contact_person_name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
                supervisor_name?.toLowerCase().includes(searchTerm.toLowerCase()) ||
                department_names?.toLowerCase().includes(searchTerm.toLowerCase())
            );
        })
        : [];

    const sortedData = filteredData.sort((a, b) => {
        if (sortConfig.key) {
            const order = sortConfig.direction === 'asc' ? 1 : -1;
            return a[sortConfig.key] > b[sortConfig.key] ? order : -order;
        }
        return 0;
    });

    return (
        <>
            {
                sortedData.length > 0 ? (
                    sortedData.map((curData => {
                        const { id, name, contact_person_name, supervisor_name, department_names } = curData;
                        //const depName = department_names && department_names.split(',');

                        return (
                            <>
                                <tr
                                    key={id}

                                    className={`clickable ${selectedRow.id === id ? 'selected' : ''}`}
                                >
                                    <td>{id}</td>
                                    <td>{name}</td>
                                    <td>{contact_person_name}</td>
                                 
                                    <td>{supervisor_name}</td>
                                    <td>
                                        {department_names}
                                        {/*<ul>
                                            {depName && depName.map((dept, index) => (
                                                <li key={index}>{dept}</li>
                                            ))}
                                        </ul>*/}
                                    </td>

                                    <td><button style={{ border: "none", backgroundColor: "white" }} onClick={() => handleEditClick(curData)}>
                                        <i class="fa-solid fa-pencil"style={{color:"darkslateblue"}}></i></button></td>

                                    <td><button className="custom-button" onClick={(event) => handleDeleteModal(id, event)}><i class="fa fa-trash" aria-hidden="true"
                                     style={{color:"red"}}></i></button></td>
                                    <td><button className="custom-button" onClick={(event) => handleView(curData, event)}>
                                        <i class="fa fa-eye" aria-hidden="true" style={{color:"darkslateblue"}}></i></button></td>

                                </tr>
                            </>
                        )
                    }))) : (
                    <span>No Supplier data available.</span>
                )
            }
            <AddSupplier
                selectedRow={selectedRow}
                setShowOffcanvas={setShowOffcanvas}
                showOffcanvas={showOffcanvas}
                setSelectedRow={setSelectedRow}
                operation={operation}
            />
        </>
    )
}

export default SupplierMasterData;